var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { IdStyles } from "../../less/IdStyles";
import { selectTooltipForOutskirtBuilding } from "../../selectors/selectTooltipInfo";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { HudButtonCooperative } from "../cooperative/HudButtonCooperative";
import { IdIcon } from "../generic/icon/IdIcon";
import { HudButtonLibrary } from "../library/HudButtonLibrary";
import { HudButtonMarket } from "../market/HudButtonMarket";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { IdTooltipAnchor, TooltipText } from "../tooltip";
import { IdTutorialFocusElement } from "../tutorial/IdTutorialFocusElement";
import { HudNavigationButton } from "./HudNavigationButton";
var NavigationModeContainerDOM = /** @class */ (function (_super) {
    __extends(NavigationModeContainerDOM, _super);
    function NavigationModeContainerDOM() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NavigationModeContainerDOM.prototype.render = function () {
        var _a = this.props, getOutskirtTooltipInfo = _a.getOutskirtTooltipInfo, onOpenMenu = _a.onOpenMenu;
        var libraryTooltipInfo = getOutskirtTooltipInfo(IdOutskirtBuildings.Library);
        return (React.createElement("div", { className: IdStyles.HudFooterBackground + " wooden-texture-background hud-player-base-navigation flex flex--aligned flex--spaced" },
            React.createElement(TooltipText, { anchor: IdTooltipAnchor.Bottom, id: IdLoca.contracts_category1 },
                React.createElement(HudButtonMarket, null)),
            React.createElement("div", { className: IdStyles.HudDivider }),
            [
                {
                    icon: IdIcon.BuildIcn,
                    id: IdTutorialFocusElement.button_building_menu,
                    loca: IdLoca.tooltip_btn_construct_web,
                    onClick: function () { return onOpenMenu(IdModal.BuildingList); },
                },
                {
                    icon: IdIcon.ShopIcn,
                    loca: IdLoca.tooltip_btn_shops_web,
                    onClick: function () { return onOpenMenu(IdModal.Store); },
                },
                {
                    icon: IdIcon.StorageIcn,
                    loca: IdLoca.tooltip_btn_storage_web,
                    onClick: function () { return onOpenMenu(IdModal.FarmManagement); },
                },
                {
                    icon: IdIcon.TopRankIcn,
                    loca: IdLoca.rankingMenu_category1,
                    onClick: function () { return onOpenMenu(IdModal.PlayerRanking); },
                },
                {
                    disabled: true,
                    icon: IdIcon.AdventureIcn,
                    loca: IdLoca.tooltip_adventureXp_web,
                },
            ].map(HudNavigationButton),
            React.createElement(TooltipText, { id: libraryTooltipInfo.id, replacements: libraryTooltipInfo.replacements, anchor: IdTooltipAnchor.BottomLeft },
                React.createElement(HudButtonLibrary, null)),
            React.createElement(HudButtonCooperative, null)));
    };
    return NavigationModeContainerDOM;
}(React.Component));
var mapState = function (state) { return ({
    getOutskirtTooltipInfo: function (idOutskirt) {
        return selectTooltipForOutskirtBuilding(state, idOutskirt);
    },
}); };
var mapDispatch = function (dispatch) { return ({
    onOpenMenu: function (modalId) { return dispatch(actionModalOpen(modalId)); },
}); };
export var NavigationModeContainer = connect(mapState, mapDispatch)(NavigationModeContainerDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/navigation/NavigationModeContainer.tsx
// module id = 2265
// module chunks = 3